const formatNumber = (value, options = {}) => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    maximumFractionDigits: 2,
    ...options,
  }).format(value);
};

export default formatNumber;
